/**
 * holds the session count for the user that was stored in localStorage
 */
class SessionCounter {
	increased = false;
	count: undefined | number;
	timeCounter: typeof TimeCounter;
	constructor(timeCounter: typeof TimeCounter) {
		this.getCurSessionCount();
		this.timeCounter = timeCounter;
	}

	/**
	 *increase session count and saves new value to localStorage
	 */
	increaseSessionCount() {
		if (this.count) {
			this.count += 1;
		} else {
			this.count = 1;
		}
		localStorage.setItem(
			"secondSessionQuestions",
			JSON.stringify({
				sessionCount: this.count
			})
		);
	}
	/**
	 * gets the current session count from localStorage, update self state
	 * @returns session count
	 */
	getCurSessionCount() {
		const count = this.count;
		if (count !== undefined) return count;
		const countStorage = localStorage.getItem("secondSessionQuestions");
		if (countStorage === null) {
			this.count = 0;
			return 0;
		}
		try {
			const countJson = JSON.parse(countStorage);
			const countFromJson = countJson?.sessionCount;
			const newVal: number = Number.isNaN(Number(countFromJson)) ? 0 : Number(countFromJson);
			this.count = newVal;
			return this.count;
		} catch (_e) {
			this.count = 0;
			return 0;
		}
	}
}

class TimeCounter {
	static initTs: number = Date.now();
	static callbacs: Record<number, (() => void)[]> = {};
	/**
	 * @description add a callback that will be triggered when the user spends a certain amount of time in the app
	 */
	static addCallbackToTime(timeToSpend: number, callback: () => void) {
		const diff = Date.now() - TimeCounter.initTs;
		if (diff >= timeToSpend) {
			callback();
			return;
		}
		setTimeout(callback, timeToSpend - diff);
	}
}
export const sessionCounter = new SessionCounter(TimeCounter);
